import React from "react";
import logo from "../../main-logo.png";

import { BrowserRouter as Router, Route, Routes, Link } from "react-router-dom";

function Logo() {
  return (
    <div>
      <Link to="/">
        <img src={logo} className="w-full h-full cursor-pointer" alt="logo" />
      </Link>
    </div>
  );
}

export default Logo;
